import type { ChecklistStepKey } from "../types";

/**
 * 清单动作路由分发回调接口
 * 各方法由消费组件注入具体实现（解耦路由跳转与原生交互依赖）
 */
export interface ChecklistActionHandlers {
  /** 跳转财务健康分页 */
  navigateToFitnessScore: () => void;
  /** 触发系统通知权限请求 (通过 useNotificationPermission hook 注入) */
  requestNotification: () => void;
  /** 打开 Plaid 投资账户连接 Flow */
  openPlaidInvest: () => void;
  /** 打开 Plaid 银行账户连接 Flow */
  openPlaidBanking: () => void;
  /** 打开建 Tracker 分类弹窗 */
  openBuildTracker: () => void;
  /** 跳转 Plan 目标激活页 */
  navigateToGoalActivation: () => void;
}

/**
 * 清单动作路由分发
 * 根据 stepKey 调用对应的 handler — fe-spec §3.3
 *
 * 所有具体实现通过 handlers 注入，使本函数与路由/原生桥解耦，
 * 便于 Sheet、信号卡、侧边栏等不同入口复用同一分发逻辑。
 */
export function handleChecklistAction(
  stepKey: ChecklistStepKey,
  handlers: ChecklistActionHandlers,
): void {
  switch (stepKey) {
    case "ff_score":
      handlers.navigateToFitnessScore();
      break;

    case "notification":
      handlers.requestNotification();
      break;

    case "invest_account":
      handlers.openPlaidInvest();
      break;

    case "banking_account":
      handlers.openPlaidBanking();
      break;

    case "tracker":
      handlers.openBuildTracker();
      break;

    case "goal":
      handlers.navigateToGoalActivation();
      break;
  }
}
